import "bootstrap-v4-rtl/js/dist/modal";
import * as firebase from "firebase/app";
import "firebase/auth";
import * as lottie from "lottie-web";
import {WPApi} from "../common/wp-api";
import {isLoggedIn} from "../common/utils";

const api = new WPApi();

const firebaseConfig = CONFIG.firebase_config;

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

let favoritesOptionsLoaded = false;
let currentStageIndex = 0;
const favorites = {
    teams: {},
    leagues: {}
};

const stages = [
    {
        title: "",
        subtitle: ""
    },
    {
        title: "בחר ליגות וענפים מועדפים",
        subtitle: "בחר ליגות מועדפות ונציג לך את כל מה שמעניין אותך."
    },
    {
        title: "בחר את הקבוצות שלך",
        subtitle: "בחר קבוצות מועדפות ונציג לך את כל מה שמעניין אותך.",
        isLast: true
    },
    {
        title: "",
        subtitle: ""
    },
    {
        title: "",
        subtitle: ""
    },
    {
        title: "",
        subtitle: ""
    },
];

let $modal;

let greenBallAnim;

let lastIndex = null;

jQuery(document).ready(($) => {


    $("[data-toggle='modal']").css('pointer-events', 'all');

    $modal = $('.bd-example-modal-lg');


    $(document).on('click', '.selection-area .selection', function () {
        let selected = $(this).hasClass('selected');
        const id = $(this).data('id');
        let $elements = $(`.selection-area  .selection[data-id="${id}"]`, $modal);
        toggleItemSelection.call(this, !selected, false);
        $elements.not(this).each(function () {
            $(this).toggleClass('selected');
        });
    });

    let animationElement = $('.green-soccer', $modal).get(0);
    const animationData = require(`../../animations/greenball.json`);

    $('.close', $modal).on('click', function (e) {
        if (!isLoggedIn()) {
            if ((currentStageIndex === 1 || currentStageIndex === 2)) {
                lastIndex = currentStageIndex;
                navigate(true, 4)
                e.preventDefault();
                return false;
            } else if (currentStageIndex === 3) {
                lastIndex = currentStageIndex;
                navigate(true, 5)
                e.preventDefault();
                return false;
            } else {
                $modal.modal('hide');
            }

        } else {
            $modal.modal('hide');
        }
    });

    $('.go-back').on('click', function () {
        navigate(true, lastIndex);
        lastIndex = null;
    });

    $('.already-has-user').on('click', function () {
        navigate(true, 3);
    })

    $('.maybe-later').on('click', function () {
        $modal.modal('hide');
    });

    $modal.on('hidden.bs.modal', function (e) {
        $(`.step-1`, $modal).fadeOut();
        $(`.step-2`, $modal).fadeOut();
        $(`.step-3`, $modal).fadeOut();
        $(`.step-4`, $modal).fadeOut();
        $(`.step-5`, $modal).fadeOut();

        currentStageIndex = 0;
        $(`.step-${currentStageIndex}`, $modal).fadeIn();

        toggleExistingFavorites(false);

        if (greenBallAnim) {
            greenBallAnim.stop();
        }

        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
    });

    $modal.on('shown.bs.modal', function (e) {
        const $clickButton = $(e.relatedTarget);
        let stage = $clickButton.data('stage');

        if (!stage) {
            if ($(animationElement).data('animation')) {
                greenBallAnim = $(animationElement).data('animation');
            } else {
                greenBallAnim = lottie.default.loadAnimation({
                    container: animationElement, // Required
                    animationData, // Required
                    renderer: 'svg', // Required
                    loop: false, // Optional
                    autoplay: false, // Optional
                    name: 'green_ball',
                });

                $(animationElement).data('animation', greenBallAnim);
            }
            greenBallAnim.play();
        }

    });

    $modal.on('show.bs.modal', async function (e) {

        const $clickButton = $(e.relatedTarget);
        let stage = $clickButton.data('stage');

        // noinspection EqualityComparisonWithCoercionJS
        if (stage == undefined) {
            stage = 0;
        }

        currentStageIndex = stage;

        /**
         * hide other stages
         * */
        let allStages = [0, 1, 2, 3, 4, 5];
        allStages.splice(currentStageIndex, 1);
        let otherStagesSelector = allStages.map((stage) => `.step-${stage}`).join(', ');
        $(otherStagesSelector, $modal).fadeOut()

        $(`.step-${currentStageIndex}`, $modal).fadeIn();

        if (!favoritesOptionsLoaded) {

            await loadRegistrationModalPart('leagues');
            lazyLoader.update();

            /**
             * Set favorites if exists
             * */
            if (pageGlobals && pageGlobals.favorites) {

                pageGlobals.favorites.leagues.forEach((id) => {
                    favorites.leagues[id] = id;
                });

                toggleExistingFavorites(true);
            }

            await loadRegistrationModalPart('teams');
            lazyLoader.update();

            $($('.selection-area .leagues .league').get(0)).click();

            if (pageGlobals && pageGlobals.favorites) {

                pageGlobals.favorites.teams.forEach((id) => {
                    favorites.teams[id] = id;
                });

                toggleExistingFavorites(true);
            }

            favoritesOptionsLoaded = true;
            lazyLoader.update();
        }

    });

    const $startButton = $('#start');

    $startButton.on('click', function () {
        navigate(true);
    });

    $('.back', $modal).on('click', function () {
        navigate(false);
    });

    $('#go-back', $modal).on('click', function () {

    });

    $('.next', $modal).on('click', async function () {
        if ($(this).data('done') && isLoggedIn()) {
            $(this).attr('disabled', 'disabled');
            await updatedFavorites(() => {
                $modal.modal('hide');
                $(this).attr('disabled', null);
                location.reload();
            });

        } else {
            navigate(true);
        }
    });

    $(document).on('click', '.selection-area .leagues .league', function () {
        const $this = $(this);
        if (!$this.hasClass('selected')) {
            const category = $this.data('category');
            $('.selection-area .leagues .league.selected').removeClass('selected');
            $this.addClass('selected');

            $('.selection-area .teams-wrapper .selection-wrapper').not(`[data-category-id="${category}"]`).fadeOut();
            $(`.selection-area .teams-wrapper .selection-wrapper[data-category-id="${category}"]`).fadeIn();
        }
    });

    $('.checkbox').on('click', function () {
        let checked = $(this).hasClass('checked');
        let newValue = !checked;
        $(this).prop('checked', newValue);
        $(this).toggleClass('checked');
        $('.login-buttons').toggleClass('disabled');
        $('.consent').toggleClass('rejected');

    });


    $('.login-buttons:not(.disabled) .login-button', $modal).on('click', async function () {

        let provider;
        if ($(this).hasClass('login-button-facebook')) {
            provider = new firebase.auth.FacebookAuthProvider();
        } else {
            provider = new firebase.auth.GoogleAuthProvider();
        }

        provider.setCustomParameters({
            'display': 'popup'
        });

        try {
            const result = await firebase.auth().signInWithPopup(provider);
            let $loader = $('.step-3 .loader-container');
            $.when($('.step-3 :not(.loader-container)').hide()).then(() => {
                $loader.show();
                $('.green-loader',$loader).show();
            });

            await logister(result.user);
        } catch (error) {
            // TODO Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            // The email of the user's account used.
            var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            var credential = error.credential;
            console.error('error', error);
        }
    });


});

let isNavigating = false;

function navigate(next, goToStage = null) {

    if (isNavigating) {
        return;
    }

    isNavigating = true;

    let nextStageIndex;
    if (goToStage != null && !isNaN(goToStage)) {
        nextStageIndex = goToStage;
    } else {
        nextStageIndex = currentStageIndex - (next ? -1 : 1);
    }

    if (!stages[currentStageIndex]) {
        return;
    }

    let elementsToShow = $(`.step-${nextStageIndex}`);
    let elementsToHide = $(`.step-${currentStageIndex}`);

    $.when($(elementsToHide, $modal).fadeOut()).then(() => {
        $(elementsToShow, $modal).fadeIn();
        $modal.modal('handleUpdate');
        isNavigating = false;
    });

    currentStageIndex = nextStageIndex;


    const currentStageSettings = stages[currentStageIndex];

    if (currentStageSettings.isLast) {
        $('.next', $modal).text('סיימתי');
        if (isLoggedIn()) {
            $('.next', $modal).data('done', true)
        }
    } else {
        $('.next', $modal).text('המשך');
    }

    $('.titles-container .modal-title', $modal).text(currentStageSettings.title);
    $('.titles-container .modal-subtitle', $modal).text(currentStageSettings.subtitle);
    lazyLoader.update($modal.toArray());

}

function toggleItemSelection(shouldSelect, fillInitial = false) {

    const $this = $(this);
    const id = $this.data('id');

    const isTeam = $this.hasClass('team');

    let data = favorites.leagues;
    if (isTeam) {
        data = favorites.teams;
    }

    if (shouldSelect) {
        if (!data[id] || fillInitial) {
            $this.addClass('selected');
            data[id] = id;
            const clone = $($this.get(0)).clone();
            clone.removeClass('selection');
            let $nextEmptySlot = $('.selected-options .selection.empty').first();

            if (fillInitial) {
                $nextEmptySlot.append(clone);
                $nextEmptySlot.removeClass('empty').addClass('selected');
            } else {
                $.when($nextEmptySlot.append(clone)).then(() => {
                    $nextEmptySlot.removeClass('empty').addClass('selected');
                });
            }
        }
    } else {
        if (data[id] || fillInitial) {
            $this.removeClass('selected');
            delete data[id];
            let $elementToRemove = $(`.selected-options .selection div[data-id="${id}"]`, $modal);

            if (fillInitial) {
                $elementToRemove.parent().addClass('empty').removeClass('selected').empty();
            } else {
                let $nextNonEmptyItem = $(`.selected-options .selection:not(.empty)`, $modal);

                if ($nextNonEmptyItem.length) {
                    $elementToRemove = $elementToRemove.parent();

                    $.when($elementToRemove.addClass('empty').removeClass('selected')).then(() => {
                        let removed = $elementToRemove.detach();
                        $('.selected-options').append(removed);
                    });

                } else {
                    $.when($elementToRemove.parent().addClass('empty').removeClass('selected')).then(function () {
                        setTimeout(() => {
                            $(this).empty();
                        }, 300);
                    });
                }
            }
        }
    }
}

/**
 * @param user firebase.User
 * */
async function logister(user) {

    try {
        const idToken = await user.getIdToken(true);

        // noinspection ES6ModulesDependencies,JSUnresolvedVariable
        jQuery.ajax({
            // wp localized object
            url: ajax.url,
            type: 'post',
            data: {
                action: 'logister',
                data: {
                    id_token: idToken,
                    email: user.email,
                    favorites: {
                        teams: Object.keys(favorites.teams),
                        leagues: Object.keys(favorites.leagues)
                    }
                }
            },
            success: function (response) {
                if (response.error) {
                    console.error(error);
                } else {
                    afterUserLogin(response);
                }
            }
        });

    } catch (e) {
        console.error(e);
    }

}

/**
 * @param loginResult
 * */
function afterUserLogin(loginResult) {

    location.reload();
}

function toggleExistingFavorites(shouldSelect) {
    for (let type in favorites) {
        if (favorites.hasOwnProperty(type)) {
            for (let id in favorites[type]) {
                if (favorites[type].hasOwnProperty(id)) {
                    let $elements = $(`.selection-area  .selection[data-id="${id}"]`, $modal);

                    toggleItemSelection.call($elements.get(0), shouldSelect, true);
                    $elements.not($elements.get(0)).each(function () {
                        $(this).toggleClass('selected');
                    });
                }
            }
        }
    }
}

async function updatedFavorites(cb) {
    try {

        firebase.auth().onAuthStateChanged(async function (user) {
            if (user) {
                let token = await user.getIdToken();

                await api.post(
                    'sport1/v1/user/favorites',
                    {
                        teams: Object.keys(favorites.teams),
                        leagues: Object.keys(favorites.leagues)
                    },
                    {
                        Authorization: `Bearer ${token}`
                    }
                );

                cb();
            }
        });
    } catch (e) {
        console.error(e);
        cb(e);
    }

}

async function loadRegistrationModalPart(part) {

    let content = await api.get(`sport1/v1/user/favorites/options/modal/${part}`);

    let $partContainer = $(`#${part}-options`);
    $partContainer.html(content);
    $('.loader-container', $partContainer).addClass('.loaded');
}

